import React, { useState } from 'react'
import Layout from '../components/Layout'
import SEO from '../components/seo'
import CreditLifeSignature from '../components/insurance/CreditLifeSignature'

function SignaturePage() {
  const [submitted, setSubmitted] = useState(false)

  if (typeof window === 'undefined') {
    return <div />
  }

  const params = new URLSearchParams(window.location.search)
  const id = params.get('id')

  if (!id) {
    return (
      <Layout noHeader noMoku noFooter>
        <SEO title="Sign Document" />
        <p style={{ padding: '2rem', textAlign: 'center' }}>Invalid link. No document ID provided.</p>
      </Layout>
    )
  }

  if (submitted) {
    return (
      <Layout noHeader noMoku noFooter>
        <SEO title="Sign Document" />
        <p style={{ padding: '2rem', textAlign: 'center' }}>Thank you! Your signature has been submitted successfully.</p>
      </Layout>
    )
  }

  return (
    <Layout noHeader noMoku noFooter>
      <SEO title="Sign Document" />
      <CreditLifeSignature
        id={id}
        open={true}
        setOpen={(val) => { if (!val) setSubmitted(true) }}
      />
    </Layout>
  )
}

export default SignaturePage